import { Grid } from "@mui/material";
import React from "react";

const Separador = () => {
  return (
    <Grid
      item
      xs={12}
      sx={{
        borderBottom: "2px dashed rgb(0, 0, 0, 0.4)",
      }}
    ></Grid>
  );
};

export default Separador;
